import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

import { fromTrafficHistory, CarTrafficSelectors, CarTrafficActions } from '@ruby/modules/car-traffic/store/car-load.index';
import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';

@Component({
  selector: 'ng-car-load-container',
  templateUrl: './car-load.container.html',
  styleUrls: ['./car-load.container.scss']
})
export class CarLoadContainer  {
  customerSelectedId!: string;
  store$: Observable<{ state: fromTrafficHistory.State; customerSelected?: ICustomer }>;

  constructor(private store: Store<fromTrafficHistory.State>) {
    this.store$ = this.store.select(CarTrafficSelectors.selectCarTrafficCoreState).pipe(
      debounceTime(1),
      tap((st: { state: fromTrafficHistory.State; customerSelected?: ICustomer }) => {
        if (st.customerSelected && st.customerSelected.masterPrimarySix && st.customerSelected.masterPrimarySix !== this.customerSelectedId) {
          this.customerSelectedId = st.customerSelected.masterPrimarySix;
          this.dispatchLoadResults();
        }
      })
    );
  }

  /**
   * Dispatch Load Results
   *
   * @summary Dispatch car traffic history action
   * @returns void
   */
  dispatchLoadResults(): void {
    this.store.dispatch(CarTrafficActions.loadTrafficHistory({ data: this.customerSelectedId }));
  }
}
